import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '../components';
import { PassKeyFAQs } from '../data/passwordless/passKeyFAQs';
import { PassKeyFacts } from '../data/passwordless/passKeyFacts';

export const Route = createFileRoute('/passwordless')({
  component: Passwordless,
});

function Passwordless() {
  // NAVIGATION FROM TANSTACK ROUTER
  const navigate = useNavigate();
  const [moreInfoRequested, setMoreInfoRequested] = React.useState(false);

  return (
    <>
      <div className="mt-4 flex h-screen flex-col items-center">
        <div className="mt-8 w-5/6">
          <h1 className="mt-8 text-center text-4xl">ATTENTION:</h1>
          <h1 className="text-center text-3xl">
            We have recently upgraded to passwordless authentication for all new patient accounts. Before you proceed,
            review the updated instructions below.
          </h1>
          <div className="mt-4 flex w-full flex-row justify-center gap-2">
            <div className="flex w-5/6 flex-col items-center px-6">
              <img
                src="https://storage.googleapis.com/mideoid-console-public/passwordless/screenCap.png"
                alt="mideo_logo"
              />
            </div>
          </div>
          <div className="flex justify-center">
            <button
              className="ml-2 text-xl text-blue-500 underline"
              onClick={() => {
                setMoreInfoRequested(!moreInfoRequested);
              }}
            >
              More Info
            </button>
          </div>
          {moreInfoRequested && (
            <div>
              <h2 className="mt-4 text-2xl">The Basics:</h2>
              <ul className="mt-2 text-xl">
                {PassKeyFacts.map((fact) => (
                  <li key={fact}>- {fact}</li>
                ))}
              </ul>
              <h2 className="mt-4 text-2xl">Frequently Asked Questions:</h2>
              <div className="mt-2">
                {PassKeyFAQs.map((faq) => (
                  <div key={faq.id} className="container">
                    <details className="mb-1 border-2 border-stone-500 bg-slate-200 p-4 open:bg-slate-50 open:[&_svg]:-rotate-180">
                      <summary className="flex cursor-pointer list-none items-center gap-4 text-xl">
                        <div>
                          <svg
                            className="rotate-0 transform text-blue-700 transition-all duration-300"
                            fill="none"
                            height="20"
                            width="20"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>
                        <div>{faq.Q}</div>
                      </summary>
                      <p className="text-xl">{faq.A}</p>
                    </details>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="mt-6 mb-24">
          <Button
            id="continue"
            type="button"
            onClick={() => navigate({ to: '/login' })}
            textContent="Return to Login Page"
          />
        </div>
      </div>
    </>
  );
}
